import React, { FC } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib/theme';
import { BottomSheetProps, Button } from '@shared/ui/molecules';
import { Text } from '@shared/ui/atoms';
import { CrossIcon } from '@shared/assets/icons';
import steamLoginVideo from '../../assets/steam-login.mp4';
import steamLoginImg from '../../assets/steamLogin.jpg';
type ModalContentProps = Pick<BottomSheetProps, 'onClose'>;
const ModalContent: FC<ModalContentProps> = ({
  onClose
}) => {
  const router = useRouter();
  const handleGoToAccountClick = () => {
    router.push('https://store.steampowered.com/account/');
  };
  return <>
      <HeaderWrapper>
        <Text family="MTSWide" size="h6" weight="bold" color="primary">
          Где взять логин Steam?
        </Text>
        <IconButtonWrapper type="button" onClick={onClose}>
          <CrossIcon />
        </IconButtonWrapper>
      </HeaderWrapper>
      <Text family="MTSCompact" size={{
      desktop: 'pL',
      mobile: 'pM'
    }} weight="medium" color="secondary">
        Логин — это то, что вы указываете при&nbsp;входе в&nbsp;Steam. Если вы укажете неверный логин, то средства уйдут
        другому пользователю
      </Text>
      <VideoWrapper>
        <video autoPlay muted loop playsInline src={steamLoginVideo} />
      </VideoWrapper>
      {/* <ImageWrapper>
        <Image src={steamLoginImg} alt="Где найти логин Steam" width={536} height={240} />
       </ImageWrapper> */}
      <Button type="button" size={{
      desktop: '72',
      mobile: '52'
    }} onClick={handleGoToAccountClick}>
        Перейти к аккаунту
      </Button>
    </>;
};
export default ModalContent;
const HeaderWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderWrapper",
  class: "h4mnef2",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.tertiary;
const IconButtonWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "IconButtonWrapper",
  class: "i4kanx3",
  propsAsIs: false,
  vars: {
    "i4kanx3-0": [_exp()]
  }
}));
const VideoWrapper = /*#__PURE__*/styled('div')({
  name: "VideoWrapper",
  class: "vc0c93g",
  propsAsIs: false
});
const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "i52hnf3",
  propsAsIs: false
});

require("./ModalContent.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./ModalContent.tsx");